export default "__VITE_ASSET__BxHnH2d2__"